import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { HealthHistoryFilterState } from '@libs/store';

@Component({
  selector: 'lib-health-history-filter',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './health-history-filter.component.html',
  styleUrl: './health-history-filter.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HealthHistoryFilterComponent {
  public readonly filterState = input.required<HealthHistoryFilterState>();
  public readonly filterChanged = output<HealthHistoryFilterState>();

  protected readonly isCriticalFilterEnabled = computed(() => this.filterState() === 'critical' || this.filterState() === 'both');
  protected readonly isActiveFilterEnabled = computed(() => this.filterState() === 'active' || this.filterState() === 'both');

  protected toggleCriticalFilter(): void {
    this.onFilterChanged(!this.isCriticalFilterEnabled(), this.isActiveFilterEnabled());
  }

  protected toggleActiveFilter(): void {
    this.onFilterChanged(this.isCriticalFilterEnabled(), !this.isActiveFilterEnabled());
  }

  protected onFilterChanged(isCritical: boolean, isActive: boolean): void {
    if (isCritical && isActive) {
      this.filterChanged.emit(HealthHistoryFilterState.Both);
    } else if (isCritical) {
      this.filterChanged.emit(HealthHistoryFilterState.Critical);
    } else if (isActive) {
      this.filterChanged.emit(HealthHistoryFilterState.Active);
    } else {
      this.filterChanged.emit(HealthHistoryFilterState.None);
    }
  }
}
